class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.element = this

    this.addEventListener('click', (event) => {
      event.preventDefault();

      this.cartItems = this.closest('cart-items') || this.closest('cart-drawer-items') || document.querySelector('.template-cart cart-items');
      const bundleId = this.dataset.bundleId;
      this.checkHasAttribute = element => element.hasAttribute(`data-product-no-free-sample`);
      this.cartItemsProducts = this.cartItems.querySelectorAll('.cart-item');
      this.cartItemsProductsArray = Array.from(this.cartItemsProducts);
      this.countProductNotSample = this.cartItemsProductsArray.filter(this.checkHasAttribute).length
      this.isFreeMessage = this.hasAttribute("data-free-message");

      if (this.isFreeMessage) {
        this.cartItems.updateQuantity(this.dataset.index, 0, "", null, true); //reload cart page after remove product

      } else if (this.countProductNotSample > 1) {

        if (bundleId) {
          // if product is a Container for bundle, remove all bundle's products
          const update = {}
          const bundleItems = document.querySelectorAll(`[data-bundle-id="${bundleId}"]`)

          bundleItems.forEach(button => {
            update[button.dataset.key] = 0;
          })

          this.removeBundleItems(update)

        } else {
          this.cartItems.updateQuantity(this.dataset.index, 0, "", null, false);
        }

      } else {
        // This is the last item - maintain focus trap for cart drawer
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && cartDrawer.classList.contains('active')) {
          // Preserve focus in cart drawer by using updateQuantity instead of clearCart
          this.cartItems.updateQuantity(this.dataset.index, 0, "", null, false);
        } else {
          this.clearCart();
        }
      }



      //------------------ Manage the cart empty --------------------//
      const cartItemsNumber = this.closest('cart-items') || document.querySelector('.template-cart cart-items');


      if (cartItemsNumber) {
        // Nombre d'éléments <li> avec la classe 'cart-item'
        const nombreItemsCart = cartItemsNumber.querySelectorAll('li.cart-item').length;

        if (nombreItemsCart <= 1) {
          var emptyContainer = document.querySelector('main.cart');
          emptyContainer.classList.add('is-empty');
        }
      }


      this.addDatalayerRemoveToCart(this.element)

    });
  }

  clearCart() {
    const body = JSON.stringify({
      sections: this.cartItems.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(window.Shopify.routes.root + 'cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: body
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((state) => {
        let emptyContainer = document.querySelector('main.cart');
        if (emptyContainer) {
          emptyContainer.classList.add('is-empty');
        }
        this.updateCartState(state);

        const updateCartRender = new CustomEvent(
          'update-cart-render',
        );
        document.dispatchEvent(updateCartRender);
      })
      .catch(() => {

        this.catchCart();
      });
  }

  removeBundleItems(updates) {
    const body = JSON.stringify({
      updates,
      sections: this.cartItems.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: body,
    })
      .then(response => {
        return response.json();
      })
      .then((state) => {
        this.updateCartState(state);


      }).catch(() => {
        this.catchCart();
        const updateCartRender = new CustomEvent(
          'update-cart-render',
        );
        document.dispatchEvent(updateCartRender);
      });
  }

  updateCartState(state) {
    const parsedState = state;
    const focusSnap =
      typeof window.captureCartFocus === 'function' ? window.captureCartFocus(document.activeElement) : null;

    this.cartItems.classList.toggle('is-empty', parsedState.item_count === 0);

    // Focus on the empty text when the cart becomes empty
    if (parsedState.item_count === 0) {
      setTimeout(() => {
        const emptyText = document.querySelector('.cart__empty-text');
        if (emptyText) {
          emptyText.setAttribute('tabindex', '-1');
          emptyText.focus();
        }
      }, 300);
    }
    const cartDrawerWrapper = document.querySelector('cart-drawer');
    const cartFooter = document.getElementById('main-cart-footer');

    if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
    if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

    this.cartItems.getSectionsToRender().forEach((section => {
      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      elementToReplace.innerHTML =
        this.cartItems.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
    }));

    this.cartItems.updateLiveRegions(null, parsedState.item_count);

    document.dispatchEvent(new CustomEvent('update-cart-render'));
    
    // For cart drawer, use the enhanced focus trap method after clearing cart
    if (cartDrawerWrapper && cartDrawerWrapper.reapplyFocusTrap) {
      // Increased delay to ensure DOM is fully updated after clearing cart
      setTimeout(() => {
        cartDrawerWrapper.reapplyFocusTrap(parsedState.item_count === 0 ? null : focusSnap);
      }, 200);
    } else {
      // Fallback for older logic
      const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
      if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
        cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
      } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
        trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
      } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
        // Si l'élément n'existe plus (supprimé), mettre le focus sur la liste parent
        const cartItemsList = document.querySelector('[data-cart-list-items]');
        if (cartItemsList) {
          cartItemsList.setAttribute('tabindex', '-1');
          trapFocus(cartDrawerWrapper, cartItemsList);
        } else {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
      }
      else {
          setTimeout(() => {
            const cartItemsList = document.querySelector('[data-cart-list-items]');
            if (cartItemsList) {
              cartItemsList.focus();
            }
          }, 100);
        }
    }

    if (
      parsedState.item_count > 0 &&
      typeof window.scheduleRestoreCartFocus === 'function' &&
      (!cartDrawerWrapper || !cartDrawerWrapper.classList.contains('active'))
    ) {
      window.scheduleRestoreCartFocus(focusSnap);
    }

    this.cartItems.disableLoading();
  }

  catchCart() {
    this.cartItems.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
    const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');

    errors.textContent = window.cartStrings.error;
    errors.classList.add('is-error', 'u-mb-15', 't-text', 't-text--12')
    setTimeout(() => {
      errors.classList.add('u-hidden')
    }, 5000);
    this.cartItems.disableLoading();
  }

  addDatalayerRemoveToCart(element) {
    this.totalPriceCart = element.dataset.totalPriceCart;
    this.productTitle = element.dataset.productTitle;
    this.productId = element.dataset.productId;
    this.productPrice = element.dataset.productPrice;
    this.productOldPrice = element.dataset.productCompareAtPrice;
    this.productCoupon = element.dataset.productCoupon;
    this.productDiscount = element.dataset.productDiscount;
    this.productIndex = element.dataset.index;
    this.itemCat = element.dataset.itemCategory;
    this.itemCat2 = element.dataset.itemCategory2;
    this.itemListId = element.dataset.itemListId;
    this.itemListName = element.dataset.itemListName;
    this.productQuantity = element.dataset.productQuantity;
    this.locationId = element.dataset.locationId;
    this.actualQuantity = element.dataset.selectActualQuantity



    const dataLayerClear = {
      ecommerce: null
    };
    window.dataLayer.push(dataLayerClear);

    const dataLayerRemoveFromCart = {
      event: 'remove_from_cart',
      ecommerce: {
        currency: window.Shopify.currency.active,
        value: Number(this.productPrice * this.actualQuantity || this.productPrice),
        value_nodiscount: Number(this.productOldPrice * this.actualQuantity || this.productPrice),
        items: [{
          item_name: String(this.productTitle),
          item_id: String(this.productId),
          coupon: null,
          discount: Number(this.productDiscount),
          index: Number(this.productIndex || undefined),
          item_category: String(this.itemCat),
          item_category2: String(this.itemCat2),
          item_list_id: Number(this.itemListId || undefined),
          item_list_name: String(this.itemListName || undefined),
          location_id: String(this.locationId || undefined),
          price: Number(this.productPrice),
          price_nodiscount: Number(this.productOldPrice || this.productPrice),
          quantity: String(this.productQuantity),
        },],
      },
    };
    window.dataLayer.push(dataLayerRemoveFromCart);

  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      if (!event.target.classList.contains('t-checkbox')) {
        this.onChange(event);
      }
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    // if element if child of <cart-free-item>, this element do not need update here
    const isChildFreeItem = event.target.parentNode.classList.contains('cart-free-item')
    if (isChildFreeItem) return;

    if (!event.target.dataset.index) return; // this is not a quantity updated

    this.updateQuantity(event.target.dataset.index, event.target.value, event.target.getAttribute('name'), event.target.getAttribute('id'));
  }


  getSectionsToRender() {
    return [{
      id: 'main-cart-items',
      section: document.getElementById('main-cart-items').dataset.id,
      selector: '.js-contents',
    },
    {
      id: 'cart-icon-bubble',
      section: 'cart-icon-bubble',
      selector: '.shopify-section'
    },
    {
      id: 'cart-live-region-text',
      section: 'cart-live-region-text',
      selector: '.shopify-section'
    },
    {
      id: 'main-cart-footer',
      section: document.getElementById('main-cart-footer').dataset.id,
      selector: '.js-contents',
    },
    {
      id: 'announcement-bar',
      section: document.getElementById('announcement-bar')?.dataset.id,
      selector: '.js-contents-announcement',
    }
    ];
  }

  updateQuantity(line, quantity, name, elementId = null, reload = false) {
    this.enableLoading(line);

    const focusSnap =
      typeof window.captureCartFocus === 'function' ? window.captureCartFocus(document.activeElement) : null;

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {
      ...fetchConfig(),
      ...{
        body
      }
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        if (reload) window.location.reload();

        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        // The re-rendered drawer HTML ships with the cross-sell aside inert again
        if (cartDrawerWrapper && cartDrawerWrapper.classList.contains('active') && cartDrawerWrapper.removeInert) {
          cartDrawerWrapper.removeInert();
        }

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);

        document.dispatchEvent(new CustomEvent('update-cart-render'));

        // For cart drawer, use the enhanced focus trap method
        if (cartDrawerWrapper && cartDrawerWrapper.reapplyFocusTrap) {
          // If cart is becoming empty, force focus trap during transition
          if (parsedState.item_count === 0 && cartDrawerWrapper.forceFocusTrapDuringTransition) {
            cartDrawerWrapper.forceFocusTrapDuringTransition();
          } else {
            // Normal case - increased delay to ensure DOM is updated
            setTimeout(() => {
              cartDrawerWrapper.reapplyFocusTrap(focusSnap);
            }, 200);
          }
        } else {
          // Fallback for non-drawer cart or if reapplyFocusTrap is not available
          // Focus management: prioritize elementId if provided, then fall back to name attribute
          let focusElement = null;
          if (elementId) {
            focusElement = document.getElementById(elementId);
          } else if (lineItem && name) {
            focusElement = lineItem.querySelector(`[name="${name}"]`);
          }

          if (focusElement) {
            cartDrawerWrapper ? trapFocus(cartDrawerWrapper, focusElement) : focusElement.focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            // Si l'élément n'existe plus (supprimé), mettre le focus sur la liste parent
            const cartItemsList = document.querySelector('[data-cart-list-items]');
            if (cartItemsList) {
              cartItemsList.setAttribute('tabindex', '-1');
              trapFocus(cartDrawerWrapper, cartItemsList);
            } else {
              trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
            }
          }
          else {
          setTimeout(() => {
            const cartItemsList = document.querySelector('[data-cart-list-items]');
            if (cartItemsList) {
              cartItemsList.focus();
              }
            }, 100);
          }
        }

        if (
          typeof window.scheduleRestoreCartFocus === 'function' &&
          (!cartDrawerWrapper || !cartDrawerWrapper.classList.contains('active'))
        ) {
          window.scheduleRestoreCartFocus(focusSnap);
        }

        this.disableLoading();
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');

        errors.textContent = window.cartStrings.error;
        errors.classList.add('is-error', 'u-mb-15', 't-text', 't-text--12')
        setTimeout(() => {
          errors.classList.add('u-hidden')
        }, 5000);
        this.disableLoading();
        const updateCartRender = new CustomEvent(
          'update-cart-render',
        );
        document.dispatchEvent(updateCartRender);
      });
  }

  updateLiveRegions(line, itemCount) {
    const lineItemError = line != null
      ? document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`)
      : null;

    if (!lineItemError) {
      this.currentItemCount = itemCount;
      this.lineItemStatusElement.setAttribute('aria-hidden', true);
      const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
      cartStatus.setAttribute('aria-hidden', false);
      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1000);
      return;
    }

    if (this.currentItemCount === itemCount) {
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);

      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    } else {

      lineItemError?.classList.add('is-error');

    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.stringYourMessage = this.dataset.stringYourMessage || 'message';
      const messageProductId = this.dataset.messageProductId;
      const messageVariantId = this.dataset.messageVariantId;
      this.cartItems = this.closest('cart-items') || this.closest('cart-drawer-items') || document.querySelector('.template-cart cart-items');
      this.expandableId = this.closest('.js-expandable').id;
      this.elLoader = this.querySelector('.loading-overlay');

      this.addEventListener('change', debounce((event) => {

        this.elLoader.classList.remove('u-hidden');

        const note_message = {
          note: event.target.value
        };

        // if the country is France, we add the message as an attribute
        if (Shopify.country == 'FR') {
          note_message.attributes = {
            [`${this.stringYourMessage}`]: event.target.value
          }
        }

        const body = JSON.stringify(note_message);

        fetch(`${routes.cart_update_url}`, {
          ...fetchConfig(),
          ...{
            body
          }
        }).then(() => {
          // if a product is selected in backoffice, we use this product to add the message in its properties
          if (messageVariantId) {
            this.manageProductGift(event.target.value, messageVariantId, messageProductId);
          } else {
            this.elLoader.classList.add('u-hidden');
          }
        });


      }, 300))
    }

    /**
     * Manages the addition, update, or removal of a product in the cart based on the provided message.
     *
     * - If a message is provided and the product is not in the cart, adds the product with the message.
     * - If a message is provided and the product is already in the cart, updates the product's message.
     * - If no message is provided and the product is in the cart, removes the product from the cart.
     *
     * @async
     * @param {string} message - The gift message to associate with the product. If empty or falsy, the product will be removed.
     * @param {string|number} variantId - The variant ID of the product to manage.
     * @param {string|number} productId - The product ID to identify the product in the cart.
     * @returns {Promise<void>}
     */
    async manageProductGift(message, variantId, productId) {
      this.msgProductKey = this.cartItems.querySelector(`li[data-productid="${productId}"]`)?.dataset.productKey;

      if (message && !this.msgProductKey) {
        this.addProductMessage(variantId, message);
      } else if (message && this.msgProductKey) {
        this.changeProductMessage(this.msgProductKey, message);
      } else if (!message && this.msgProductKey) {
        this.removeProductMessage(this.msgProductKey);
      }

    }


    /**
     * Fetches updated cart data from the server and updates the cart UI sections accordingly.
     *
     * @async
     * @param {string} route_api - The API route to fetch cart data from (without the `.js` extension).
     * @param {Object} body - The request payload to send to the server.
     * @returns {Promise<Object>} The updated cart state returned from the server.
     */
    async fetchCart(route_api, body) {

      const focusSnap =
        typeof window.captureCartFocus === 'function' ? window.captureCartFocus(document.activeElement) : null;

      const options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
      };

      body.sections = this.cartItems.getSectionsToRender().map((section) => section.section);
      body.sections_url = window.location.pathname;
      options.body = JSON.stringify(body);

      const response = await fetch(`${route_api}.js`, options);
      const state = await response.json();

      // Rerender sections in cart
      this.cartItems = this.closest('cart-items') || this.closest('cart-drawer-items') || document.querySelector('.template-cart cart-items');
      const parsedState = state;

      this.cartItems.getSectionsToRender().forEach((section => {
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

        elementToReplace.innerHTML =
          this.cartItems.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      }));

      // After rendering the sections, re-instantiate the Expandable elements.
      const updateCartRender = new CustomEvent(
        'update-cart-render',
        {
          bubbles: true,
          detail: { isOpen: true, id: this.expandableId },
        }
      );
      document.dispatchEvent(updateCartRender);

      if (typeof window.scheduleRestoreCartFocus === 'function') {
        window.scheduleRestoreCartFocus(focusSnap);
      }

      return state;
    }

    addProductMessage(productId, message) {
      let formData = {
        'items': [{
          'id': productId,
          'quantity': 1,
          'properties': {
            [`${this.stringYourMessage}`]: message
          }
        }]
      };

      this.fetchCart(routes.cart_add_url, formData);
    }

    changeProductMessage(productId, message) {
      let formData = {
        'id': productId,
        'quantity': 1,
        'properties': {
          [`${this.stringYourMessage}`]: message
        }
      };

      this.fetchCart(routes.cart_change_url, formData);
    }

    removeProductMessage(key) {
      let formData = {
        'updates': {
          [key]: 0
        }
      };

      this.fetchCart(routes.cart_update_url, formData);
    }

  });
};

class CartChangeVariant extends HTMLElement {
  constructor() {
    super();

    this.element = this
    this.cartItems = this.closest('cart-items') || this.closest('cart-drawer-items') || document.querySelector('.template-cart cart-items');
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const { type } = this.dataset;

    if (type === 'select') {
      // on mobile : variant are display in select
      this.elSelect = this.element.querySelector('select');
      this.elSelect.addEventListener('change', (event) => {
        event.preventDefault();
        const { dataset, id } = event.target.selectedOptions[0]
        this.replaceVariant(dataset, id);
      });

    } else if (type === 'button') {
      // Desktop: updates are driven by the associated radio `change` event in
      // connectedCallback (covers click + arrow-key selection in the radio group).
      const onKeyActivate = (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        event.stopPropagation();
        const { dataset, id } = this.element;
        this.replaceVariant(dataset, id);
      };

      // Si le custom element reçoit le focus (peu fréquent sans tabindex)
      this.element.addEventListener('keydown', onKeyActivate);
    }
  }

  connectedCallback() {
    if (this.dataset.type !== 'button' || this._variantRadioBound) return;
    const radio = this.previousElementSibling;
    if (!radio?.matches?.('input[type="radio"]')) return;
    this._variantRadioBound = true;

    // Click on the label/button and arrow keys both check the radio and fire change
    radio.addEventListener('change', () => {
      this.replaceVariant(this.dataset, this.id);
    });

    // Enter activates even when the radio is already checked (change won't fire).
    // Space on an unchecked radio is covered by `change` above.
    radio.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      event.stopPropagation();
      this.replaceVariant(this.dataset, this.id);
    });
  }

  /**
   * Replaces a product variant in the cart with a new variant and updates the cart state.
   *
   * @async
   * @param {Object} dataset - The dataset containing information about the cart item and variant.
   * @param {string} dataset.itemKey - The current variant key in the cart.
   * @param {string} dataset.itemId - The current variant ID in the cart.
   * @param {number|string} dataset.itemQuantity - The current variant quantity in the cart.
   * @param {number} dataset.itemIndex - The current index of the item in the cart.
   * @param {string} dataset.variantId - The variant ID of the new variant to switch to.
   * @param {number|string} dataset.variantInventoryQuantity - The available inventory quantity for the new variant.
   * @returns {Promise<void>} Resolves when the cart has been updated and the UI has been adjusted.
   */
  async replaceVariant(dataset, id) {

    const { itemKey, itemId, itemQuantity, itemIndex, variantId, variantInventoryQuantity } = dataset;

    const parsedItemQty = Number(itemQuantity);
    const parsedVarInvQty = Number(variantInventoryQuantity);

    const newVariantQty = parsedItemQty >= parsedVarInvQty ? parsedVarInvQty : parsedItemQty;

    const focusSnap =
      typeof window.captureCartFocus === 'function' ? window.captureCartFocus(document.activeElement) : null;

    this.handleLoading(itemId, true);

    const data = await this.updateCart(itemKey, variantId, newVariantQty);
    if (!data) return this.handleLoading(itemId, false);

    this.updateCartState(data, itemIndex, parsedItemQty, parsedVarInvQty);

    const headerHeight = document.querySelector('header')?.offsetHeight || 0;
    const yOffset = -headerHeight;
    const y = this.cartItems.getBoundingClientRect().top + window.scrollY + yOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });

    this.handleDatalayerCart(dataset, 'variant_remove_from_cart');
    const elNewVariant = document.querySelector(`#${id}`);
    this.handleDatalayerCart(elNewVariant.dataset, 'variant_add_to_cart');

    const updateCartRender = new CustomEvent('update-cart-render');
    document.dispatchEvent(updateCartRender);

    if (typeof window.scheduleRestoreCartFocus === 'function') {
      window.scheduleRestoreCartFocus(focusSnap);
    }
  }

  async updateCart(itemKey, variantId, newVariantQty) {
    const updates = {};
    updates[itemKey] = 0;
    updates[variantId] = newVariantQty;

    return await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        updates,
        sections: this.cartItems.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      })
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        return data;
      })
      .catch((error) => {
        console.error('Error:', error);
        this.catchCart();
      });
  }

  /**
   * Toggles the loading state for a specific cart item line.
   *
   * @param {number|string} line - The identifier for the cart item line.
   * @param {boolean} force - A boolean indicating whether to force the loading state.
   *                          If true, the loading state is enabled; otherwise, it is disabled.
   */
  handleLoading(line, force) {
    const cartItemElements = this.cartItems.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartItemVariantName = this.cartItems.querySelectorAll(`#CartItem-${line} .cart-item__variant-name`);
    const cartChangeVariantEl = this.cartItems.querySelectorAll(`#CartItem-${line} cart-change-variant`);

    [...cartItemElements].forEach((overlay) => overlay.classList.toggle('u-hidden', !force));
    [...cartItemVariantName].forEach((variantName) => variantName.classList.toggle('u-hidden', force));
    [...cartChangeVariantEl].forEach((cartChangeVar) => cartChangeVar.classList.toggle('u-cursor-pointer', !force));
    [...cartChangeVariantEl].forEach((cartChangeVar) => cartChangeVar.classList.toggle('u-pointer-events-none', force));

    force && document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', !force);
  }

  updateCartState(state, line, itemQuantity, variantInvQty) {
    const parsedState = state;
    const varQtyChanged = itemQuantity > variantInvQty;

    this.cartItems.getSectionsToRender().forEach((section => {
      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      elementToReplace.innerHTML =
        this.cartItems.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
    }));

    if (varQtyChanged) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);

      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
      lineItemError.classList.add('is-error');
    }

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);
    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);

    this.cartItems.disableLoading();
  }

  catchCart() {
    this.cartItems.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
    const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');

    errors.textContent = window.cartStrings.error;
    errors.classList.add('is-error', 'u-mb-15', 't-text', 't-text--12')
    setTimeout(() => {
      errors.classList.add('u-hidden')
    }, 5000);
    this.cartItems.disableLoading();
  }

  handleDatalayerCart(dataset, event) {

    const {
      totalPriceCart,
      productTitle,
      productId,
      productPrice,
      productCompareAtPrice: productOldPrice,
      productCoupon,
      productDiscount,
      index: productIndex,
      itemCategory: itemCat,
      itemCategory2: itemCat2,
      itemListId,
      itemListName,
      productQuantity,
      locationId,
      selectActualQuantity: actualQuantity
    } = dataset;

    const dataLayerClear = {
      ecommerce: null
    };
    window.dataLayer.push(dataLayerClear);

    const dataLayerFromCart = {
      event: event,
      ecommerce: {
        currency: window.Shopify.currency.active,
        value: Number(productPrice * actualQuantity || productPrice),
        items: [{
          item_name: String(productTitle),
          item_id: String(productId),
          coupon: null,
          discount: Number(productDiscount),
          index: Number(productIndex || undefined),
          item_category: String(itemCat),
          item_category2: String(itemCat2),
          item_list_id: Number(itemListId || undefined),
          item_list_name: String(itemListName || undefined),
          location_id: String(locationId || undefined),
          price: Number(productPrice),
          quantity: String(productQuantity),
        },],
      },
    };
    window.dataLayer.push(dataLayerFromCart);

  }
}

customElements.define('cart-change-variant', CartChangeVariant);